import React from 'react'
import PropTypes from 'prop-types'

import { DashboardModule, Form } from '@domain-group/suit-theme'

import EntitySelectBox from '@components/EntitySelectBox'

const Details = (props) => {
  const { serviceProductForm } = props

  const {
    entityState: {
      reference_title,
      service_id,
      title,
    },
    errors,
    handlers,
  } = serviceProductForm

  return (
    <DashboardModule title="Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="* Service" errorMessage={errors.service_id}>
            <EntitySelectBox
              entityKey="services"
              name="service_id"
              value={service_id}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="* Title" errorMessage={errors.title} marginTop={['large', 0]}>
            <input type="text" name="title" value={title} {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Reference Title">
            <input
              name="reference_title"
              type="text"
              value={reference_title}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

Details.propTypes = {
  serviceProductForm: PropTypes.object.isRequired,
}

export default Details
